import { FC, ReactNode } from "react";
import { getStaticUrl } from "../../utils";
import { Button } from '../ui-kit/RoundButton';
import { BuyTicketWrapper } from "../tickets/BuyTicketWrapper";
import { Link } from "../Link";

interface TeamInfoProps {
    name: string;
    logo: string;
}
const TeamInfo: FC<TeamInfoProps> = ({
    name,
    logo,
}) => {
    let titleClassNames = "text-center";
    if (name.length > 20) {
        titleClassNames += ' ';
    } else {
        titleClassNames += ' text-xl';
    }
    return (
        <div className="flex flex-col items-center w-28">
            <img src={getStaticUrl(logo)} className="w-20 h-20 object-contain" />
            <div className={titleClassNames}>{name}</div>
        </div>
    );
}


interface CalendarEventProps {
    name: string;
    url: string;
    date: string;
    team1: {
        name: string;
        logo: string;
    };
    team2: {
        name: string;
        logo: string;
    };
    score?: ReactNode;
    matchUrl?: string;
    ticketUrl?: string;
    parkingUrl?: string;
    classNames?: string;
}

export const CalendarEvent: FC<CalendarEventProps> = ({
    name,
    url,
    date,
    team1,
    team2,
    score,
    matchUrl,
    ticketUrl,
    parkingUrl,
    classNames = 'text-white bg-sky-950/95 ',
}) => {
    const containerClassNames = "box-border hover:shadow-md transition-all rounded-xl min-w-full min-h-32 h-60 flex flex-col items-center justify-start gap-4 px-4 py-3 " + classNames;
    let tournamentTitleClassNames = "text-inherit hover:no-underline text-center mx-auto";
    if (name && name.length >= 28) {
        tournamentTitleClassNames += " text-lg";
    } else {
        tournamentTitleClassNames += " text-xl";
    }
    return (
        <div className={containerClassNames} style={{ fontFamily: "'Futura', sans-serif" }}>
            <div className="text-center h-16 flex flex-col justify-center items-center">
                {name && <Link to={url} className={tournamentTitleClassNames}>{name}</Link>}
                <div className="text-center text-2xl font-medium">
                    {date}
                </div>
            </div>
            <div className="flex flex-row justify-between w-full font-medium">
                <TeamInfo name={team1.name} logo={team1.logo} />
                <div className="h-20 flex flex-col items-center justify-center gap-1">
                    {score && <a href={matchUrl} className="text-inherit hover:no-underline">
                        {score}
                    </a>}
                    {!score && !ticketUrl && <div className="text-5xl font-medium pb-3">
                        -:-
                    </div>}
                    {!score && ticketUrl && <>
                        <BuyTicketWrapper url={ticketUrl}><Button title="Билет" size="xs" className="italic border border-solid border-slate-100 rounded-full" /></BuyTicketWrapper><div id="scrollTo" />
                        {!!parkingUrl && <BuyTicketWrapper url={parkingUrl}><div><span title="Въезд на парковку" className="px-2 text-white bg-sky-600 hover:bg-sky-500 border-2 border-solid border-white rounded-lg text-xl font-bold">P</span></div></BuyTicketWrapper>}
                    </>}
                </div>
                <TeamInfo name={team2.name} logo={team2.logo} />
            </div>
        </div>
    );
}